const EMAIL_SAFE_IMAGE_TYPES = new Set(["image/jpeg", "image/png"]);

export type EmailThumbnailStorage = {
  getFullUrlOfAsset: (
    assetOriginalName: string,
    folder: string,
    projectId?: string
  ) => string;
  uploadFileToS3: (
    key: string,
    file: File,
    type?: string,
    progressCallback?: (progress: { loaded: number; total?: number }) => void
  ) => Promise<{ key: string }>;
};

type UploadEmailThumbnailBackgroundInput = {
  cdnBaseUrl: string;
  file: File;
  onProgress?: (progress: { loaded: number; total?: number }) => void;
  projectId: string;
  storage: EmailThumbnailStorage;
};

export const uploadEmailThumbnailBackground = async ({
  cdnBaseUrl,
  file,
  onProgress,
  projectId,
  storage,
}: UploadEmailThumbnailBackgroundInput): Promise<string> => {
  if (!EMAIL_SAFE_IMAGE_TYPES.has(file.type.toLowerCase())) {
    throw new Error("Choose a JPG or PNG image.");
  }

  const key = storage.getFullUrlOfAsset(
    file.name,
    "email-thumbnails",
    projectId
  );
  const uploaded = await storage.uploadFileToS3(
    key,
    file,
    file.type,
    onProgress
  );

  return `${cdnBaseUrl.replace(/\/$/, "")}/${uploaded.key.replace(/^\//, "")}`;
};
